module.exports = __webpack_public_path__ + "static/img/image2we@2x.bd1bb6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/image2we@2x.png
// module id = 430
// module chunks = 1